import { ApolloLink } from "@apollo/client";
import removeDirectives from "../../shared/utils/removeDirectives";
/*
 * This is a temporary link to remove directives added by our existing plugins (babel and swc).
 * The directives it removes are tag and hash.
 * tag won't be used anymore as it was used to identify which schema a query belonged to.
 * hash is used in prefetch to deduplicate queries, which is also something no longer necessary.
 * In the future, we might tweak the plugins so the directives are only added to queries going through the old route.
 */ export default function createDirectivesCleanupLink() {
    return new ApolloLink(function directivesCleanupLink(operation, forward) {
        const { gql } = removeDirectives(operation.query);
        operation.query = gql;
        return forward(operation);
    });
}

//# sourceMappingURL=createDirectivesCleanupLink.js.map